var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncreasedVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23603_14456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8C8.48987 8.00006 8.96267 8.17991 9.32874 8.50543C9.69481 8.83095 9.92869 9.2795 9.986 9.766L10 10V36H40C40.5098 36.0006 41.0001 36.1958 41.3707 36.5457C41.7414 36.8956 41.9645 37.3739 41.9943 37.8828C42.0242 38.3917 41.8587 38.8928 41.5315 39.2837C41.2043 39.6746 40.7402 39.9258 40.234 39.986L40 40H8C7.51013 39.9999 7.03733 39.8201 6.67126 39.4946C6.30519 39.1691 6.07131 38.7205 6.014 38.234L6 38V10C6 9.46957 6.21071 8.96086 6.58579 8.58579C6.96086 8.21071 7.46957 8 8 8ZM40.388 13.636C42.188 13.636 43.088 15.812 41.816 17.084L30.676 28.224C30.2635 28.6362 29.7042 28.8677 29.121 28.8677C28.5378 28.8677 27.9785 28.6362 27.566 28.224L22.05 22.708L14.98 29.778C14.605 30.1533 14.0962 30.3642 13.5657 30.3644C13.0352 30.3646 12.5263 30.154 12.151 29.779C11.7757 29.404 11.5648 28.8952 11.5646 28.3647C11.5644 27.8342 11.775 27.3253 12.15 26.95L20.494 18.606C20.6983 18.4016 20.9409 18.2395 21.2079 18.1288C21.4748 18.0182 21.761 17.9613 22.05 17.9613C22.339 17.9613 22.6252 18.0182 22.8921 18.1288C23.1591 18.2395 23.4017 18.4016 23.606 18.606L29.122 24.122L35.606 17.636H34.778C34.2476 17.636 33.7389 17.4253 33.3638 17.0502C32.9887 16.6751 32.778 16.1664 32.778 15.636C32.778 15.1056 32.9887 14.5969 33.3638 14.2218C33.7389 13.8467 34.2476 13.636 34.778 13.636H40.388Z",
    fill: "#F77C47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23603_14456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreasedVisibility);
export default __webpack_public_path__ + "static/media/increased-visibility.b2d5ddaf8290924c3c8e5f7a8e491add.svg";
export { ForwardRef as ReactComponent };